import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Segment,
  Loader,
  Text,
  Flex,
  Provider,
} from "@fluentui/react-northstar";
import ImageTitleContainer from "../ImageTitleContainer";
import EmailSentImage from "../../../assets/images/undraw_message_sent_1030.svg";
import Constants from "../../../constants/text-constants";
import InputBoxGroup from "../../atoms/InputBoxGroup";

const ForgottenPasswordEnterCodeStep = (props) => {
  const {
    gotoSignIn,
    testId,
    resetCode,
    handleValueChange,
    id,
    onSubmit,
    resetInputs,
    validating,
    error,
  } = props;

  const onChange = (values) => {
    if (handleValueChange) {
      handleValueChange(id, values);
    }
  };

  let content = (
    <React.Fragment>
      <InputBoxGroup
        values={resetCode}
        testId={testId + "InputGroup"}
        onChange={onChange}
        onSubmit={onSubmit}
        resetInputs={resetInputs}
        hasError={error}
      />
      <Text data-testid={"inputGroupError"} error>
        {error}
      </Text>
    </React.Fragment>
  );

  if (validating) {
    content = (
      <Loader
        label={Constants.VALIDATING_CODE}
        data-testid={testId + "Loader"}
      />
    );
  }

  const bgClass = "forgotten-password-code-step segment";

  return (
    <Provider.Consumer
      render={(theme) => (
        <Segment
          className={
            theme.siteVariables.themeString === "dark"
              ? bgClass + " dark"
              : bgClass
          }
          data-testid={testId + "Segment"}
        >
          <ImageTitleContainer
            image={EmailSentImage}
            title={Constants.ENTER_DIGIT_CODE}
            subTitle={Constants.ENTER_VERIFICATION_CODE}
            testId={testId}
          >
            <Flex column fill>
              {content}
            </Flex>
            <Button
              text
              content={Constants.BACK_TO_SIGN_IN}
              data-testid={testId + "BackBtn"}
              onClick={gotoSignIn}
            />
          </ImageTitleContainer>
        </Segment>
      )}
    ></Provider.Consumer>
  );
};

ForgottenPasswordEnterCodeStep.propTypes = {
  gotoSignIn: PropTypes.func,
  handleValueChange: PropTypes.func,
  onSubmit: PropTypes.func,
  resetInputs: PropTypes.func,
  resetCode: PropTypes.array,
  id: PropTypes.string,
  validating: PropTypes.bool,
  error: PropTypes.string,
  testId: PropTypes.string,
};

ForgottenPasswordEnterCodeStep.defaultProps = {
  resetCode: [],
  validating: false,
  error: "",
  testId: "",
};

export default ForgottenPasswordEnterCodeStep;
